module.exports = __webpack_public_path__ + "img/redeem-25k.74d5a388.png";